export default class CtverecProKresleni {
	readonly x: number;
	readonly y: number;
	readonly strana: number;
	readonly barva: string;

	constructor(x: number, y: number, strana: number, barva: string) {
		this.x = x;
		this.y = y;
		this.strana = strana;
		this.barva = barva;
	}
}
